var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 17.7087H5.83366C5.49199 17.7087 5.20866 17.4253 5.20866 17.0837C5.20866 16.742 5.49199 16.4587 5.83366 16.4587H14.167C16.5503 16.4587 17.7087 15.3003 17.7087 12.917V7.08366C17.7087 4.70033 16.5503 3.54199 14.167 3.54199H5.83366C3.45033 3.54199 2.29199 4.70033 2.29199 7.08366C2.29199 7.42533 2.00866 7.70866 1.66699 7.70866C1.32533 7.70866 1.04199 7.42533 1.04199 7.08366C1.04199 4.04199 2.79199 2.29199 5.83366 2.29199H14.167C17.2087 2.29199 18.9587 4.04199 18.9587 7.08366V12.917C18.9587 15.9587 17.2087 17.7087 14.167 17.7087Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 10.725C9.29998 10.725 8.59165 10.5083 8.04998 10.0666L5.44164 7.98331C5.17498 7.76664 5.12498 7.37497 5.34165 7.10831C5.55831 6.84164 5.94997 6.79164 6.21664 7.00831L8.82497 9.09164C9.45831 9.59998 10.5333 9.59998 11.1666 9.09164L13.775 7.00831C14.0416 6.79164 14.4416 6.83331 14.65 7.10831C14.8666 7.37497 14.825 7.77498 14.55 7.98331L11.9416 10.0666C11.4083 10.5083 10.7 10.725 9.99998 10.725Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 14.375H1.66699C1.32533 14.375 1.04199 14.0917 1.04199 13.75C1.04199 13.4083 1.32533 13.125 1.66699 13.125H6.66699C7.00866 13.125 7.29199 13.4083 7.29199 13.75C7.29199 14.0917 7.00866 14.375 6.66699 14.375Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 11.042H1.66699C1.32533 11.042 1.04199 10.7587 1.04199 10.417C1.04199 10.0753 1.32533 9.79199 1.66699 9.79199H4.16699C4.50866 9.79199 4.79199 10.0753 4.79199 10.417C4.79199 10.7587 4.50866 11.042 4.16699 11.042Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsTracking);
export default __webpack_public_path__ + "static/media/sms-tracking.f337fa79f8a4ada1675b1a3b313a781c.svg";
export { ForwardRef as ReactComponent };